import React, { useState } from "react";

export default function TextForm(props) {
  const handleUpClick = () => {
    let newText = text.toUpperCase();
    setText(newText);
    props.showAlert("Converted to uppercase!","success")
  };
  const lowerCase = () => {
    let newText = text.toLowerCase();
    setText(newText);
    props.showAlert("Converted to lowercase!","success")
  };
  const onClear = () => {
    let newText = "";
    setText(newText);
    props.showAlert("Text has been cleared!","success")
  };
  const handleCopy = () => {
    let copyText  = document.getElementById("myBox");
    copyText.select();
      
   navigator.clipboard.writeText(copyText.value);
   props.showAlert("Copied to clipboard!","success")
    
  };
  const handleExtraSpace = () => {
    let newText =text.replace(/ +/g, ' ');
    setText(newText)
    props.showAlert("Extra spaces removed!","success")

    
  };
  const [text, setText] = useState("");

  const onchange = (event) => {
    setText(event.target.value);
  };

  return (
    <>
    <div className="container"style={{color : props.mode ==='dark'?'white':'#042743'}}>
      <h1>{props.heading}</h1>
      <div className="mb-3">
        <textarea placeholder="Enter text Here" className="form-control" value={text} id="myBox" rows="8" onChange={onchange} style={{backgroundColor : props.mode ==='dark'?'grey':'white', color : props.mode ==='dark'?'white':'#042743'}}></textarea>
      </div>
      <button className="btn btn-primary mx-1" onClick={handleUpClick}> Convert to upperCase </button>
      <button className="btn btn-primary mx-1" onClick={lowerCase}> Convert to lowerCase </button>
      <button className="btn btn-primary mx-1" onClick={onClear}> Clear </button>
      <button className="btn btn-primary mx-1" onClick={handleCopy}>Copy</button>
      <button className="btn btn-primary mx-1" onClick={handleExtraSpace}>Remove Extra Spaces</button>
    </div>
    <div className="container my-3" style={{color : props.mode ==='dark'?'white':'#042743'}}>
<h2>Your text Summary</h2>
<p id="wordCount">{text.split(" ").length} Words and {text.length} characters</p>
<p>{0.008 * text.split(" ").length} minutes read!!</p>
<h3>Preview</h3>
<p>{text.length > 0 ?text:"Enter text above to preview it here!"}</p>

    </div>
    </>
  );
}
